import { getStaticPath } from '@/helpers/static-path';

/* global __webpack_public_path__:writable */
/* exported __webpack_public_path__ */
__webpack_public_path__ = getStaticPath();
